import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

const Collapsible = ({data,category,itemSubCategory,setItemSubCategory}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };





  return (
    <div>

          <FaChevronDown  style={{
            position: 'absolute',
            right: '0',
            top: '0',
            marginRight: '8px',
            transition: 'transform 0.3s ease',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }} onClick={toggleCollapse} />
                  
      <div
        style={{
          paddingLeft: '8px',
          marginTop: '1px',
          display: isOpen ? 'flex' : 'none', 
          flexDirection: 'column',
        }}
      >
        {data?.length > 0 && (
        data?.map((subCategory)=>{
          return<Link to={`/products/${category?._id}/${subCategory._id}`}>
          <input 
            className="mx-2" 
            type="checkbox" 
            checked={itemSubCategory === subCategory._id}
            onChange={() => { setItemSubCategory(itemSubCategory === subCategory?._id ? "" : subCategory?._id)  }} 
          />
          {subCategory?.name}
        </Link>
        })    
        )}
      </div>
    </div>
  );
};

export default Collapsible;
